<main>
    <pme-consulta-shop-window
        *ngIf="this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas'"></pme-consulta-shop-window>
    <pme-recarga-pontual-shop-window
        *ngIf="this.classificationIdentifier === 'plano-mensal-recarga-pontual'"></pme-recarga-pontual-shop-window>
    <pme-consulta-campaign-shop-window
        *ngIf="this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas-campanha'">
    </pme-consulta-campaign-shop-window>
</main>